import { Component, Input } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/shared/filtering';
import { FormControlFactory } from '../../services/form-control-factory.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SubmissionConstants } from 'src/app/modules/energy-credits/models/constants/submissions-constants';
import { UsStateService } from '../../services/form-us-state.service';
import { DYNAMIC_ERROR_STATE_MATCHER } from '../../services/dynamic-control-error-state-matcher';


@Component({
    selector: 'lib-sbra-dropdown-control',
    imports: [
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule
],
    templateUrl: './sbra-dropdown-control.component.html',
    styleUrl: './sbra-dropdown-control.component.scss'
})
export class SbraDropdownControlComponent {
  @Input() control: DynamicFormControl;
  @Input() isReadonly: boolean;
  inputControl: FormControl;
  errorStateMatcher = DYNAMIC_ERROR_STATE_MATCHER;
  climateZone: any;
  formStructureId: any;
  ogSelectOptions: any[];
  selectOptions: any[];

  private _subscriptions: Subscription[] = [];

  constructor(
    private filterService: FilterService,
    public formControlService: FormControlFactory,
    private stateService: UsStateService,
    private submissionConstant: SubmissionConstants,
  ) {
    this.formStructureId = localStorage.getItem(
      this.submissionConstant.formStructureIdKey,
    );
    this.climateZone = localStorage.getItem(
      this.submissionConstant.climateZoneKey,
    );
  }

  ngOnInit() {
    this.ogSelectOptions = this.control.customOptions?.selectOptions;
    //check the climate zone value to set dropdown options
    if (this.formStructureId === '2') {
      this.checkClimateZone();
    } else {
      this.selectOptions = this.control.customOptions?.selectOptions;
    }

    if (
      this.formStructureId === '2' &&
      this.control.formControls[0].formControl.parent
    ) {
      const homeStateControl =
        this.control.formControls[0].formControl.parent.get('homeState');

      if (homeStateControl) {
        let stateSub = homeStateControl.valueChanges.subscribe((stateCode) => {
          if (stateCode) {
            this.updateClimateZoneFromState(stateCode);
          }

          this.control.setValue(null);

          if (
            this.control.formControls[0].formControl.parent.get('status')
              .value !== 'Ready To Submit'
          ) {
            this.control.formControls[0].formControl.setErrors(null);
          }
        });
        this._subscriptions.push(stateSub);
      }
    }

    let sub = this.filterService.activeFilterRemoved$.subscribe({
      next: (i) => {
        if (i.propertyBinding === this.control.propertyBinding) {
          this.control.formControls[0].formControl.setValue(null);
        }
      },
      error: (e) => console.log(e),
    });

    this._subscriptions.push(sub);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }

  checkClimateZone() {
    function getFilter(climateZone: string): (x: any) => boolean {
      switch (climateZone) {
        case '1':
          return (x) => x.value.includes('1');
        case '2':
          return (x) => x.value.includes('2');
        case '3':
          return (x) => x.value.includes('3');
        default:
          return (x) => true;
      }
    }

    this.selectOptions = this.ogSelectOptions.filter(
      getFilter(this.climateZone),
    );
  }

  /**
   * This will update the SBRA design package option dropdown depending on the climate zone
   * Climate zone is determines based on the state specified on the submission
   */
  private updateClimateZoneFromState(stateCode: string): void {
    // States should be loaded by now since service called getAllStates()
    const states = this.stateService.stateList;
    const newClimateZone = (states ?? [])
      .find((state) => state.StateCode === stateCode)
      ?.HUDClimateZone?.toString();

    if (newClimateZone) {
      this.climateZone = newClimateZone;
      localStorage.setItem(
        this.submissionConstant.climateZoneKey,
        newClimateZone,
      );
      this.checkClimateZone();
      this.control.formControls[0].formControl.setValue(null);
    }
  }
}
